import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import partial from 'lodash/partial';
import { bindActionCreators } from 'redux';
import { toggleAvatarSelector, selectAvatar } from 'profile/ducks/view';
import EditMeta from 'profile/components/edit_meta';
import { PROFILE_FORM } from 'profile/constants';

export function mapStateToProps(state) {
  const { profile: { view } } = state;
  if (!view.data) {
    return null;
  }

  const selector = formValueSelector(PROFILE_FORM);
  const avatar = selector(state, 'avatar');

  return {
    ...view,
    ...view.data,
    avatar
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    selectAvatar,
    toggleSelect: toggleAvatarSelector,
    updateAvatar: partial(change, PROFILE_FORM, 'avatar'),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditMeta);



// WEBPACK FOOTER //
// ./profile/containers/edit_meta.js